const Parceiros = () => {

    return (
        <div>
            <h1>Parceiros</h1>
        </div>
    )
}

export default Parceiros
